import CustomTable from '@/components/common/table/CustomTable'
import TableCell from '@/components/common/table/TableCell'
import TableRow from '@/components/common/table/TableRow'

export {
  CustomTable,
  TableCell,
  TableRow
}